export var isEntity = function (value) {
    if (!value)
        return false;
    return typeof value === 'object'
        && 'legalName' in value
        && 'status' in value
        && 'siren' in value;
};
export var isEntities = function (value) { return Array.isArray(value)
    && value.every(isEntity); };
